import styled from "styled-components";

interface AppContainerProps {
  height?: string;
  color?: string;
}

export const AppContainer = styled.div<AppContainerProps>`
  height: ${props => props.height};
  text-align: center;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${props => props.color || 'var(--primary-color)'};
`;

export const Container = styled.form`
  width: 410px;
  align-self: center;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
  padding: 30px 56px;
  background: white;
  margin-left: 40vw;
  margin-bottom: 20px;
  margin-top: 7vh;
`;

interface DisclaimerProps {
  marginBottom?: string;
}

export const Disclaimer = styled.p<DisclaimerProps>`
  font-size: 12px;
  font-family: "Inter", sans-serif;
  color: #56565d;
  text-align: left;
  margin-left: 8px;
  margin-top: 0;
  margin-bottom: ${props => props.marginBottom};
  line-height: 18px;
`;

export const Title = styled.p`
  font-size: 30px;
  font-weight: 600;
  text-align: left;
  background: linear-gradient(270.09deg, #030d69 -2%, #194ddd 57.73%, #573aa6 96.88%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: "Inter";
  background-clip: text;
  margin-bottom: 36px;
  line-height: 36px;
  margin-top: 0;
`;

export const BlackTitle = styled.p`
  font-size: 1.6em;
  font-weight: 600;
  text-align: center;
  width: 100%;
  font-family: "Nunito";
  background-clip: text;
  margin-top: 10px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

interface InputTextProps {
  Width?: string;
  isError?: boolean;
  Img?: string;
}

export const InputText = styled.input<InputTextProps>`
  width: ${props => props.Width};
  height: 40px;
  border: 1px solid;
  border-color: ${props => (props.isError ? "#7396ba" : "#FC2F3E")};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 12px;
  background-image: url(${props => props.Img});
  background-repeat: no-repeat;
  background-position: 97%;

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
    -webkit-transition-delay: 9999s;
  }
`;

interface ErrorContainerProps {
  margin?: string;
}

export const ErrorContainer = styled.div<ErrorContainerProps>`
  display: flex;
  width: 300px;
  align-items: center;
  margin: ${props => props.margin};
`;

interface IconProps {
  marginRight?: string;
  marginLeft?: string;
  marginTop?: string;
}

export const Icon = styled.img<IconProps>`
  width: 16px;
  height: 16px;
  margin-right: ${props => props.marginRight};
  margin-left: ${props => props.marginLeft};
  margin-top: ${props => props.marginTop};
`;

interface LinkProps {
  textDecoration?: string;
  width?: string;
}

export const Link = styled.a<LinkProps>`
  font-family: "Inter", sans-serif;
  font-size: 14px;
  text-decoration: ${props => props.textDecoration};
  color: #1a4af0;
  cursor: pointer;
  display: flex;
  width: ${props => props.width};
  justify-content: space-between;
  text-decoration: underline;
`;

interface ParagraphProps {
  marginBottom?: string;
}

export const Paragraph = styled.p<ParagraphProps>`
  font-size: 14px;
  color: #10264a;
  text-align: left;
  line-height: 21px;
  margin-top: 0;
  margin-bottom: ${props => props.marginBottom};
  font-family: "Inter", sans-serif;
  width: 100%;
`;

interface ResendProps {
  Color?: string;
  Decoration?: string;
}

export const Resend = styled.p<ResendProps>`
  color: ${props => props.Color};
  cursor: pointer;
  text-decoration: ${props => props.Decoration};
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ValidatorContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 308px;
  font-size: 12px;
  margin-bottom: 23px;
  margin-top: 5px;
  color: #5c7199;
`;

export const DisclaimerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const ValidationItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
`;

export const ErrorText = styled.p`
  color: #fc2f3e;
  font-size: 14px;
  text-align: left;
  margin: 14px 0 0 5px;
`;